<template>
  <div class="icon-base" :class="{textlink: isTextlinkIcon, movielink: !isTextlinkIcon, playlistTextMenu: isPlaylistTextMenu, open: isOpened}">
    <div class="icon">
      <template v-if="iconType === secIconType.text">
        <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="17" height="20" rx="2" :fill="iconColor"/>
          <path d="M5 6H12" :stroke="iconBgColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M5 10H12" :stroke="iconBgColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M5 14H12" :stroke="iconBgColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </template>
      <template v-else-if="iconType === secIconType.movie">
        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="22" height="16" rx="2" :fill="iconColor"/>
          <path d="M14.25 7.56699C14.5833 7.75944 14.5833 8.24056 14.25 8.43301L9.75 11.0311C9.41667 11.2235 9 10.983 9 10.5981L9 5.40192C9 5.01702 9.41667 4.77646 9.75 4.96891L14.25 7.56699Z" :fill="iconBgColor"/>
        </svg>
      </template>
    </div>
  </div>
</template>

<script>
import { MENU_SEC_TYPES, SEC_ICON_TYPE } from '@/CONSTS/MENUS.js'

export default {
  name: "LinkIcon",
  data() {
    return {
      iconColor: '#FF7497',
      iconBgColor: 'white'
    }
  },
  props: {
    iconType: {
      type: Number,
      default() {
        return SEC_ICON_TYPE.text
      }
    },
    isPlaylistTextMenu: {
      type: Boolean,
      default: false
    },
    isOpened: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    secIconType() {
      return SEC_ICON_TYPE
    },
    baseClassStr() {
      let clsstr = this.iconType === SEC_ICON_TYPE.text ? 'textlink' : 'movielink'
      if (this.isPlaylistTextMenu) clsstr += ' playlist-text-menu'
      return clsstr
    },
    isTextlinkIcon() {
      return this.iconType === SEC_ICON_TYPE.text
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.icon-base {
  //background: url('/static/img/common/arrow_right.svg') no-repeat right center;
  background-size: auto 24px;
  padding-right: 24px;
  display: inline-block;
  position: relative;
  .icon {}
  &.textlink {
    .icon {
      width: 17px;
      height: 20px;
    }
  }
  &.movielink {
    .icon {
      width: 22px;
      height: 16px;
      top: 26px;
    }
  }
  &::before {
    content: "";
    background: url('/static/img/common/arrow_right.svg') no-repeat right center;
    background-size: auto 24px;
    position: absolute;
    width: 24px;
    height: 24px;
    display: inline-block;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    transition: transform 200ms ease-out 0s;
  }
  &.playlistTextMenu {
    .icon {
      margin-right: 6px;
    }
    &::before {
      transform: rotate(90deg);
    }
    &.open {
      &::before {
        transform: rotate(-90deg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/LinkIcon.vue